var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 714.61 173.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3,.cls-6{fill:#004677;}.cls-4,.cls-5{fill:#939598;}.cls-5,.cls-6{fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 714.61,
    height: 173.32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UC_Logo_Horizontal",
    "data-name": "UC Logo Horizontal"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M228.93,108.25l-.29-7.46c-4,5.55-9.37,8.9-16.93,8.9-4.39,0-8.13-1.25-10.8-3.73-3.35-3.06-4.5-7.08-4.5-12.53V71.72c0-4.49-.19-7.17-2-8V63.4h6.22V93.24c0,3.73.67,7.17,3.16,9.76,2.2,2.19,5,3.34,9.08,3.34,6.7,0,12.34-4.87,15.78-10.61V63.4h4.21V95.92a100.44,100.44,0,0,0,.57,12.33Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M284.77,108.25h-4.21V78.32c0-3.63-.57-7.17-3.15-9.75-2.2-2.3-5-3.35-9.09-3.35-6.69,0-12.34,4.88-15.78,10.52v32.51h-4.21V71.72c0-4.49-.19-7.17-2-8V63.4h6.21v7.37c4-5.55,9.37-8.9,16.93-8.9,4.4,0,8.22,1.24,10.8,3.64,3.35,3.15,4.5,7.17,4.5,12.62Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M304.46,63.4v44.86h-4.3V71.72c0-4.49-.19-7.17-2-8V63.4Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M346.16,107.39a22.23,22.23,0,0,1-9.66,2.4c-8.23,0-13.2-4.79-13.2-13.3V66.94h-7.65V63.4h7.65V52.12l4.21-3.54V63.4h16.16v3.54H327.51V96.78c0,6.22,3.63,9.56,9.66,9.56h.38a19,19,0,0,0,8.61-2.48Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M355.71,85.11c.1,13.39,8.52,20.56,18.27,21.23.57,0,1.24.1,1.91.1a28.06,28.06,0,0,0,14.25-3.92l.58,3.54c-4.4,2.48-9.85,3.82-16.36,3.82-13.48,0-22.95-10.14-22.95-24.1,0-13.68,9.09-24,21.61-24,5.93,0,10.71,1.91,14,5.45,3.63,3.92,5.35,9.66,5.35,17.88ZM388,81.86c-.29-10.62-5.93-16.64-15.11-16.64-8.51,0-15.78,6.88-17,16.64Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437.28,108.25l-.28-4.87c-4,5.06-9.57,6.31-14.35,6.31-13.1,0-21.71-9.75-21.71-23.91S410.89,61.87,424,61.87a19.54,19.54,0,0,1,13,4.4V49.73c0-4.5-.2-7.18-1.92-8V41.4h6.22V95.92a99.44,99.44,0,0,0,.57,12.33ZM437,70.67a18.34,18.34,0,0,0-12.34-5.45c-10.43,0-19.51,7.17-19.51,20.56v1c0,12.72,8.13,19.51,18.46,19.51A16.8,16.8,0,0,0,437,99.36Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M498,107.59a25.37,25.37,0,0,1-10.8,2.29c-14.25,0-24.68-10.14-24.68-24S473,61.78,487.23,61.78A25.37,25.37,0,0,1,498,64.07V68a26.38,26.38,0,0,0-11.09-2.68c-11.57,0-20.18,8.61-20.18,20.56s8.61,20.47,20.18,20.47A26.23,26.23,0,0,0,498,103.66Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M544.79,108.64a7.68,7.68,0,0,1-4.11,1,4.79,4.79,0,0,1-1.24-.1,5.62,5.62,0,0,1-4.69-5.64c-3.54,3.92-7.84,5.84-13.77,5.84h-1a13.36,13.36,0,0,1-8-2.4,11,11,0,0,1-4.21-8.89c0-14.92,17.89-16.74,25.54-16.74h1.14V75.93c0-7.27-3.92-10.81-11.38-10.81a22.15,22.15,0,0,0-12.62,4.31V65.79c2.68-2,7.65-3.92,13.77-3.92,6.51,0,14.44,3.06,14.44,13.39v26.4c0,2.48.29,3.73,1.34,4.59a3.05,3.05,0,0,0,1.91.57,5.83,5.83,0,0,0,2.87-.86Zm-10.33-24.2-1.24.1c-17.12,1.34-21.13,7.84-21.13,13.19,0,6.22,3.82,9.19,9.94,9.19a16.33,16.33,0,0,0,12.43-6.41Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M575.1,109.79a20.42,20.42,0,0,1-14.44-5.93v29.83h-4.3v-62c0-4.49-.19-7.17-2-8V63.4h6.31v5.93A19.33,19.33,0,0,1,576,62c12.53,0,20.47,9.47,20.47,23.91,0,12.14-6.89,23.91-21.33,23.91m.39-44.48a17.7,17.7,0,0,0-14.83,9.09V98.5a17.74,17.74,0,0,0,14.44,7.75c11.29,0,17-9.66,17-20.37,0-12.82-7.37-20.57-16.64-20.57",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M611.82,63.4v44.86h-4.31V71.72c0-4.49-.19-7.17-2-8V63.4Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M653.51,107.39a22.16,22.16,0,0,1-9.66,2.4c-8.22,0-13.19-4.79-13.19-13.3V66.94H623V63.4h7.66V52.12l4.2-3.54V63.4H651v3.54H634.86V96.78c0,6.22,3.64,9.56,9.66,9.56h.39a19,19,0,0,0,8.6-2.48Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M698.84,108.64a7.74,7.74,0,0,1-4.12,1,4.83,4.83,0,0,1-1.24-.1,5.62,5.62,0,0,1-4.69-5.64c-3.53,3.92-7.84,5.84-13.77,5.84h-.95a13.37,13.37,0,0,1-8-2.4,11.06,11.06,0,0,1-4.2-8.89c0-14.92,17.88-16.74,25.53-16.74h1.15V75.93c0-7.27-3.92-10.81-11.38-10.81a22.15,22.15,0,0,0-12.63,4.31V65.79c2.68-2,7.65-3.92,13.78-3.92,6.5,0,14.44,3.06,14.44,13.39v26.4c0,2.48.28,3.73,1.34,4.59a3,3,0,0,0,1.91.57,5.86,5.86,0,0,0,2.87-.86Zm-10.33-24.2-1.24.1c-17.12,1.34-21.14,7.84-21.14,13.19,0,6.22,3.82,9.19,9.94,9.19a16.35,16.35,0,0,0,12.44-6.41Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M714.61,41.41v66.85H710.4V49.73c0-4.5-.19-7.18-2-8v-.28Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45.2,111.83a54.77,54.77,0,0,1-2.47,12.83c-15.79,4.34-26.51,12-29.7,19.76-3.28,8,2.84,18,12.11,14.93,30.55-10.16,24.24-71,22.48-94.2a65.57,65.57,0,0,0,18.57,4.44c4.57,22-3.77,77.24-32.33,95.58C23.85,171.6,0,176.52,0,157.57,0,143.63,18,124,45.2,111.83",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M59.26,45.2a54.87,54.87,0,0,1-12.84-2.47c-4.34-15.79-12-26.51-19.76-29.7-7.95-3.28-18,2.84-14.93,12.11,10.16,30.55,71,24.24,94.21,22.48a64.9,64.9,0,0,0-4.44,18.57c-22,4.57-77.25-3.77-95.59-32.33C-.52,23.85-5.44,0,13.51,0,27.45,0,47.12,18,59.26,45.2",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M126.39,60.69a54.19,54.19,0,0,1,2.48-12.83c15.78-4.35,26.5-12,29.7-19.76,3.27-8-2.84-18-12.12-14.93-30.54,10.15-24.24,71-22.48,94.2a64.9,64.9,0,0,0-18.57-4.44c-4.57-22,3.77-77.25,32.33-95.58C147.74.92,171.59-4,171.59,15c0,13.93-18,33.61-45.2,45.74",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M111.53,128.12a54.19,54.19,0,0,1,12.83,2.48c4.35,15.78,12,26.5,19.76,29.7,8,3.28,18-2.84,14.93-12.12-10.15-30.54-71-24.24-94.2-22.48a64.9,64.9,0,0,0,4.44-18.57c22-4.57,77.25,3.77,95.58,32.33,6.43,10,11.35,33.86-7.6,33.86-13.93,0-33.61-18-45.74-45.2",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M84.48,42.17A16.91,16.91,0,1,0,67.57,25.26,16.94,16.94,0,0,0,84.48,42.17",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M84.48,165a16.91,16.91,0,1,1,16.92-16.91A16.92,16.92,0,0,1,84.48,165",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M7.34,89.89a16.91,16.91,0,1,1,20.71,12,16.91,16.91,0,0,1-20.71-12",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M164.25,89.9a16.91,16.91,0,1,1-12-20.72,16.91,16.91,0,0,1,12,20.72",
    transform: "translate(0 0)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogo);
export default __webpack_public_path__ + "static/media/company_logo.8ace08a89b060f336475fea7223677d8.svg";
export { ForwardRef as ReactComponent };